// Simple Redux module for Client ATS
const LOAD_BRIEF = 'twineApp/clientATS/LOAD_BRIEF';
const LOAD_BRIEF_SUCCESS = 'twineApp/clientATS/LOAD_BRIEF_SUCCESS';
const LOAD_BRIEF_FAIL = 'twineApp/clientATS/LOAD_BRIEF_FAIL';

const LOAD_PITCHES = 'twineApp/clientATS/LOAD_PITCHES';
const LOAD_PITCHES_SUCCESS = 'twineApp/clientATS/LOAD_PITCHES_SUCCESS';
const LOAD_PITCHES_FAIL = 'twineApp/clientATS/LOAD_PITCHES_FAIL';

const MARK_PITCH_AS_READ = 'twineApp/clientATS/MARK_PITCH_AS_READ';
const MARK_PITCH_AS_READ_SUCCESS =
  'twineApp/clientATS/MARK_PITCH_AS_READ_SUCCESS';
const MARK_PITCH_AS_READ_FAIL = 'twineApp/clientATS/MARK_PITCH_AS_READ_FAIL';

const DECLINE_PITCH = 'twineApp/clientATS/DECLINE_PITCH';
const DECLINE_PITCH_SUCCESS = 'twineApp/clientATS/DECLINE_PITCH_SUCCESS';
const DECLINE_PITCH_FAIL = 'twineApp/clientATS/DECLINE_PITCH_FAIL';

const SHORTLIST_PITCH = 'twineApp/clientATS/SHORTLIST_PITCH';
const SHORTLIST_PITCH_SUCCESS = 'twineApp/clientATS/SHORTLIST_PITCH_SUCCESS';
const SHORTLIST_PITCH_FAIL = 'twineApp/clientATS/SHORTLIST_PITCH_FAIL';

const initialState = {
  brief: null,
  pitches: [],
  loading: false,
  loadingPitches: false,
  pitchesLoaded: false,
  decliningPitch: false,
  shortlistingPitch: false,
  error: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_BRIEF:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case LOAD_BRIEF_SUCCESS:
      return {
        ...state,
        brief: action.result,
        loading: false,
      };

    case LOAD_BRIEF_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case LOAD_PITCHES:
      return {
        ...state,
        loadingPitches: true,
      };

    case LOAD_PITCHES_SUCCESS:
      return {
        ...state,
        pitches: action.result.messages || [],
        loadingPitches: false,
        pitchesLoaded: true,
      };

    case LOAD_PITCHES_FAIL:
      return {
        ...state,
        loadingPitches: false,
        pitchesLoaded: true,
        error: action.error,
      };

    case MARK_PITCH_AS_READ_SUCCESS:
      return {
        ...state,
        pitches: state.pitches.map((pitch) =>
          pitch.id === action.pitchId
            ? { ...pitch, receiver_viewed: true }
            : pitch
        ),
      };

    case MARK_PITCH_AS_READ_FAIL:
      return { ...state, error: action.error };

    case DECLINE_PITCH:
      return {
        ...state,
        decliningPitch: true,
      };

    case DECLINE_PITCH_SUCCESS:
      return {
        ...state,
        decliningPitch: false,
        pitches: state.pitches.map((pitch) =>
          pitch.id === action.pitchId
            ? { ...pitch, declined_at: new Date().toISOString() }
            : pitch
        ),
      };

    case DECLINE_PITCH_FAIL:
      return {
        ...state,
        decliningPitch: false,
        error: action.error,
      };

    case SHORTLIST_PITCH:
      return {
        ...state,
        shortlistingPitch: true,
      };

    case SHORTLIST_PITCH_SUCCESS:
      return {
        ...state,
        shortlistingPitch: false,
        pitches: state.pitches.map((pitch) =>
          pitch.id === action.pitchId
            ? { ...pitch, liked_at: new Date().toISOString() }
            : pitch
        ),
      };

    case SHORTLIST_PITCH_FAIL:
      return {
        ...state,
        shortlistingPitch: false,
        error: action.error,
      };

    default:
      return state;
  }
}

// Action creators
export function loadBrief(encodedId) {
  return {
    types: [LOAD_BRIEF, LOAD_BRIEF_SUCCESS, LOAD_BRIEF_FAIL],
    promise: (client) =>
      client.get(
        `/notices/collaboration/${encodedId}?include=user,user.avatars,invites.user.avatars`
      ),
  };
}

export function loadPitches(briefId) {
  return {
    types: [LOAD_PITCHES, LOAD_PITCHES_SUCCESS, LOAD_PITCHES_FAIL],
    promise: (client) =>
      client.get(
        `/notices/collaboration/${briefId}/pitches?include=sender,sender.avatars,sender.skills,sender.tools&paginator=100`
      ),
  };
}

export function markPitchAsRead(pitchId) {
  return {
    types: [
      MARK_PITCH_AS_READ,
      MARK_PITCH_AS_READ_SUCCESS,
      MARK_PITCH_AS_READ_FAIL,
    ],
    promise: (client) => client.patch(`/messages/viewed/${pitchId}`),
    pitchId,
  };
}

export function declinePitch(briefId, pitchId) {
  return {
    types: [DECLINE_PITCH, DECLINE_PITCH_SUCCESS, DECLINE_PITCH_FAIL],
    promise: (client) =>
      client.put(
        `/notices/collaboration/${briefId}/pitches/${pitchId}/decline`
      ),
    pitchId,
  };
}

export function shortlistPitch(briefId, pitchId) {
  return {
    types: [SHORTLIST_PITCH, SHORTLIST_PITCH_SUCCESS, SHORTLIST_PITCH_FAIL],
    promise: (client) =>
      client.put(`/notices/collaboration/${briefId}/pitches/${pitchId}/like`),
    pitchId,
  };
}
